<template>
	<div>
		<!-- Modal definition -->
		<b-modal id="modal-1" title="BootstrapVue">
			<div
				v-for="topic in currentTopics"
				:key="topic.id"
				class="m-4 d-flex justify-content-between align-items-center"
			>
				<span>{{ topic.name }}</span>
				<b-button @click="handleModalClick(topic.id)">View Report</b-button>
			</div>
		</b-modal>
		<div class="chart-container px-5 py-3">
			<div class="subject__btns relativeclass w-100">
				<b-button
					:class="this.active === 'top' ? 'usage-active' : 'usage-nonactive'"
					v-on:click="currentlyActive('top')"
					>Most Active</b-button
				>
				<b-button
					:class="this.active === 'low' ? 'usage-active' : 'usage-nonactive'"
					v-if="!barData.low || barData.low.length === 0"
					v-b-popover.hover.top="'This topic contain less than 4 tests'"
					>Least Active</b-button
				>
				<b-button
					:class="this.active === 'low' ? 'usage-active' : 'usage-nonactive'"
					v-on:click="currentlyActive('low')"
					v-else
					>Least Active</b-button
				>
				<div class="button-line"></div>
				<div id="trend-bar-top" class="px-3 m-auto"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { select } from "d3-selection";
import { scaleLinear, scaleBand } from "d3-scale";
import { axisLeft, axisBottom } from "d3-axis";
import { max } from "d3-array";
import { getTrendBarData } from "../../../utils/apiFunctions";

export default {
	name: "TrendBarGraphs",
	data() {
		return {
			active: "top",
			fill: {
				top: "#1DD1A1",
				low: "#ff0000",
			},
			currentTopics: [],
			barData: {
				top: [
					{
						name: ["JavaaaScript"],
						value: 3,
					},
					{
						name: ["Embeded Systems"],
						value: 12,
					},
					{
						name: ["Python", "Vue", "Rust"],
						value: 15,
					},
				],
				low: [
					{
						name: ["Angular"],
						value: 0,
					},
					{
						name: ["Cordova"],
						value: 1,
					},
					{
						name: ["Unity", "System Design", "Containerisation"],
						value: 2,
					},
				],
			},
		};
	},
	props: {
		subject: {
			type: String,
			validator: (value) => ["topic", "test"].indexOf(value) !== -1,
		},

		topicId: {
			type: String,
			default: null,
		},
	},
	async mounted() {
		try {
			const response = await this.getData();
			this.barData = response.data;
			this.preprocess();
			this.createChart(
				"#trend-bar-top",
				this.barData[this.active],
				this.fill[this.active]
			);
		} catch (e) {
			console.error("Error getting data", e);
		}
	},

	methods: {
		currentlyActive(type) {
			this.active = type;
			this.createChart(
				"#trend-bar-top",
				this.barData[this.active],
				this.fill[this.active]
			);
		},
		async getData() {
			const { data } = await getTrendBarData(this.subject, this.topicId);
			if (data.type !== "Success") {
				throw new Error("Request Failed");
			} else {
				return data;
			}
		},

		preprocess() {
			this.barData.top.reverse();
		},

		handleModalClick(id) {
			if (this.subject === "topic") {
				this.$router.push(`/reports/topic/${id}`);
			} else {
				this.$router.push(`/reports/test/${this.topicId}/${id}`);
			}
		},

		createChart(parentId, data, fill) {
			this.margin = {
				top: 10,
				bottom: 20,
				right: 10,
				left: 60,
			};
			const width = 900 - this.margin.left - this.margin.right;
			const rawHeight = data.length * 80 + 40;
			const height = rawHeight - this.margin.top - this.margin.bottom;
			this.letterLimit = 18;
			this.padding = 30;

			this.svg = select(parentId)
				.html("")
				.append("svg")
				.attr("viewBox", ` 0 0 ${width + 100} ${height + 100}`);

			this.graph = this.svg.append("g").attr("transform", `translate(0, 50)`);

			const rects = this.graph
				.append("g")
				.attr("id", "bars")
				.attr("transform", `translate(${this.margin.left}, 0)`);

			const maxValue = max(data, (d) => d.value) + 1;

			// Creating scales and axis
			this.topicScale = scaleBand()
				.domain([...data.map((d) => d.name)])
				.range([this.margin.top, height])
				.paddingInner(0.4)
				.paddingOuter(0.3);

			this.valueScale = scaleLinear()
				.domain([0, maxValue])
				.range([0, width]);

			//Generating Axis
			this.xAxis = axisBottom().scale(this.valueScale);

			this.yAxis = axisLeft().scale(this.topicScale);
			rects
				.selectAll("rect")
				.data(data)
				.enter()
				.append("rect")
				.attr("id", (_, index) => `bar-${index}`)
				.attr("width", (data) => this.valueScale(data.value))
				.attr("height", this.topicScale.bandwidth())
				.attr("y", (data) => this.topicScale(data.name))
				.attr("fill", fill)
				.attr("fill-opacity", 0.7)
				.on("click", (_, data) => {
					// since test page needs to have topic id as well as test id we use if
					if (data.id.length > 1) {
						// Handle bar click with multiple values
						const currentTopicsArr = [];
						for (let i = 0; i < data.id.length; i++) {
							currentTopicsArr.push({
								id: data.id[i],
								name: data.name[i],
							});
						}
						this.currentTopics = currentTopicsArr;
						this.$bvModal.show("modal-1");
						return;
					}
					if (this.subject === "topic") {
						let data1 = {
							topicName: data.name[0],
						};
						this.$store.commit("searchVUEX/saveReportDetails", data1);
						this.$router.push(`/reports/topic/${data.id}`);
					} else {
						let data1 = {
							testName: data.name[0],
							topicID: this.topicId,
						};
						this.$store.commit("searchVUEX/saveReportDetails", data1);
						this.$router.push(`/reports/test/${this.topicId}/${data.id}`);
					}
				});

			this.graph
				.append("g")
				.attr("id", "x-axis")
				.call(this.xAxis)
				.attr("transform", `translate(${this.margin.left}, ${height})`)
				.selectAll("text")
				.attr("fill", "#1818196B");
			this.yAxisGroup = this.graph
				.append("g")
				.attr("id", "y-axis")
				.call(this.yAxis)
				.attr("transform", `translate(${this.margin.left / 2}, 0)`);

			this.yAxisGroup
				.selectAll("g")
				.data(data)
				.append("title")
				.text((d) => d.name);
			this.graph
				.selectAll(".tick")
				.select("line")
				.attr("opacity", "0");
			this.yAxisGroup
				.selectAll("text")
				.data(data)
				.text((d) => {
					// Converting array to readable string
					const arrayString = d.name.toString().replaceAll(",", ", ");
					if (arrayString.length > this.letterLimit) {
						return arrayString.substr(0, this.letterLimit).concat("...");
					}
					return arrayString;
				})
				.attr("font-size", "20px")
				.attr("text-anchor", "start")
				.attr("dx", (d, index, textNodeList) => {
					const textWidth =
						textNodeList[index].getBoundingClientRect().width + this.padding;
					const barWidth = select(`#bar-${index}`)
						.node()
						.getBoundingClientRect().width;
					if (barWidth > textWidth) {
						textNodeList[index].classList.add("white");
						return this.padding + this.margin.left / 2;
					}
					textNodeList[index].style.fill = fill;
					return this.valueScale(d.value) + this.padding + this.margin.left / 2;
				});

			// Removing the default axis and replacing them with straight lines
			this.graph.selectAll(".domain").attr("opacity", "0");
			this.graph
				.append("line")
				.attr("x1", this.margin.left / 2)
				.attr("x2", this.margin.left / 2)
				.attr("y2", height)
				.attr("stroke", "#E3E3E3");
			this.graph
				.append("line")
				.attr("x1", this.margin.left / 2)
				.attr("x2", width + this.margin.right + this.margin.left)
				.attr("y1", height)
				.attr("y2", height)
				.attr("stroke", "#E3E3E3");
		},
	},
};
</script>

<style scoped>
.card-template {
	display: flex;
	background: var(--bg-white);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	transform: scale(0.95);
	width: calc(50vw);
}

.chart-container {
	width: 100%;
	display: flex;
	height: max-content;
}
</style>
<style>
rect {
	cursor: pointer;
}
text {
	font-family: "Poppins", sans-serif !important;
}
text.white {
	fill: #ffffff;
}
</style>
